import React, { useState } from 'react';

import { View } from '@amzn/stencil-react-components/layout';
import { Col } from '@amzn/stencil-react-components/layout';

import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';
import { Link } from 'react-router-dom';
import {
  CREATE_SEGMENT_PAGE,
  CREATE_CONTENT_PAGE,
  SCHEDULING_LANDING_PAGE,
  CAMPAIGN_LIST_PAGE,
  ONBOARD_PAGE,
  CREATE_JOURNEY_PAGE,
  PARENTEX_CAMPAIGN_PAGE,
} from '../constants/routesConstant';
import { PermissionLevel } from '../enums/permissionLevel';
import { PrimaryNavigation } from '../enums/applicationLinks';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useUserInfo } from '../hooks/useUserInfo';
import { FormattedMessage, useIntl } from 'react-intl';

const renderTitle = ({ titleText, toggle }) => (
  <Text fontSize="T300" onClick={toggle}>
    {titleText}
  </Text>
);

const LeftsideNavigationContainer = () => {
  const { permissionLevel } = useUserInfo();
  const { pathname: path } = useLocation();
  const markExpandedClass = 'expander-on';
  const [activeTab, setActiveTab] = useState('');

  const { formatMessage } = useIntl();

  const onExpanderClick = tabName => {
    if (tabName === activeTab) {
      setActiveTab('');
      return;
    }
    setActiveTab(tabName);
  };

  return (
    <View backgroundColor="primary05" width={'17%'} padding={'0 0 0 25px'}>
      <Col gridGap="S100">
        <View
          className={`expander-icon-to-right ${
            activeTab === PrimaryNavigation.SEGMENT ? markExpandedClass : ''
          }`}
        >
          <Expander
            renderTitle={renderTitle}
            contentSpacing={'S100'}
            isExpanded={activeTab === PrimaryNavigation.SEGMENT}
            onToggle={() => onExpanderClick(PrimaryNavigation.SEGMENT)}
            titleText={formatMessage({ id: 'app.sideNav.segments' })}
          >
            <Col padding={10} gridGap="S100">
              <Link
                className={path === CREATE_SEGMENT_PAGE ? 'selected' : ''}
                style={{ textDecoration: 'none', color: 'inherit' }}
                to={CREATE_SEGMENT_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.createSegment" />
                </Text>
              </Link>
            </Col>
          </Expander>
        </View>
        <View
          className={`expander-icon-to-right ${
            activeTab === PrimaryNavigation.CONTENT ? markExpandedClass : ''
          }`}
        >
          <Expander
            renderTitle={renderTitle}
            contentSpacing={'S100'}
            isExpanded={activeTab === PrimaryNavigation.CONTENT}
            onToggle={() => onExpanderClick(PrimaryNavigation.CONTENT)}
            titleText={formatMessage({ id: 'app.sideNav.templates' })}
          >
            <Col padding={10} gridGap="S100">
              <Link
                data-testid="create-content-link"
                className={path === CREATE_CONTENT_PAGE ? 'selected' : ''}
                style={{ textDecoration: 'none', color: 'inherit' }}
                to={CREATE_CONTENT_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.createContent" />
                </Text>
              </Link>
            </Col>
          </Expander>
        </View>
        <View
          className={`expander-icon-to-right ${
            activeTab === PrimaryNavigation.CAMPAIGN ? markExpandedClass : ''
          }`}
        >
          <Expander
            renderTitle={renderTitle}
            contentSpacing={'S100'}
            isExpanded={activeTab === PrimaryNavigation.CAMPAIGN}
            onToggle={() => onExpanderClick(PrimaryNavigation.CAMPAIGN)}
            titleText={formatMessage({ id: 'app.sideNav.campaigns' })}
          >
            <Col padding={10} gridGap="S100">
              <Link
                data-testid="create-campaign-link"
                style={{ textDecoration: 'none', color: 'inherit' }}
                className={path === SCHEDULING_LANDING_PAGE ? 'selected' : ''}
                to={SCHEDULING_LANDING_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.createCampaign" />
                </Text>
              </Link>
            </Col>
            <Col padding={10} gridGap="S100">
              <Link
                data-testid="create-journey-link"
                style={{ textDecoration: 'none', color: 'inherit' }}
                className={path === CREATE_JOURNEY_PAGE ? 'selected' : ''}
                to={CREATE_JOURNEY_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.groupCampaign" />
                </Text>
              </Link>
            </Col>
            <Col padding={10} gridGap="S100">
              <Link
                data-testid="create-parentex-link"
                style={{ textDecoration: 'none', color: 'inherit' }}
                className={path === PARENTEX_CAMPAIGN_PAGE ? 'selected' : ''}
                to={PARENTEX_CAMPAIGN_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.parentExCampaign" />
                </Text>
              </Link>
            </Col>
            <Col padding={10} gridGap="S100">
              <Link
                style={{ textDecoration: 'none', color: 'inherit' }}
                className={path === CAMPAIGN_LIST_PAGE ? 'selected' : ''}
                to={CAMPAIGN_LIST_PAGE}
              >
                <Text fontSize="T300">
                  <FormattedMessage id="app.sideNav.campaignsList" />
                </Text>
              </Link>
            </Col>
          </Expander>
        </View>
        {permissionLevel === PermissionLevel.ADMIN && (
          <View
            contentSpacing={'S100'}
            className={`expander-icon-to-right ${
              activeTab === PrimaryNavigation.ADMIN ? markExpandedClass : ''
            }`}
          >
            <Expander
              renderTitle={renderTitle}
              isExpanded={activeTab === PrimaryNavigation.ADMIN}
              onToggle={() => onExpanderClick(PrimaryNavigation.ADMIN)}
              titleText={formatMessage({ id: 'app.sideNav.registerTeam' })}
            >
              <Col gridGap="S100">
                <Link
                  data-testid="onboard-group-link"
                  className={path === ONBOARD_PAGE ? 'selected' : ''}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  to={ONBOARD_PAGE}
                >
                  <Text fontSize="T300">
                    <FormattedMessage id="app.sideNav.onboardTeam" />
                  </Text>
                </Link>
              </Col>
            </Expander>
          </View>
        )}
      </Col>
    </View>
  );
};

export default LeftsideNavigationContainer;
